module.exports = __webpack_public_path__ + "static/img/buy_antpay@3x.044d5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_antpay@3x.png
// module id = 49uI
// module chunks = 1